document.addEventListener('DOMContentLoaded', () => {
    setupQuickViewTriggers();
    
    // Listen for cart updates to reinitialize
    document.addEventListener('cart-updated', function() {
      setupQuickViewTriggers();
    });
  });
  
  function setupQuickViewTriggers() {
    // Find all quick view triggers in the cart footer that haven't been initialized
    const cartFooterQuickViewTriggers = document.querySelectorAll('.cart-footer [data-js-quick-view-trigger]:not([data-initialized])');
    
    cartFooterQuickViewTriggers.forEach(button => {
      button.setAttribute('data-initialized', 'true');
      
      // Store modal reference
      let quickViewModal = null;
      
      // Add click handler
      button.addEventListener('click', (e) => {
        e.preventDefault();
        
        // Mark this as the active element for focus return
        button.setAttribute('data-last-active', 'true');
        
        // If modal already exists, remove it and create fresh one
        // This prevents state contamination between different products
        if (quickViewModal) {
          quickViewModal.remove();
          quickViewModal = null;
        }
        
        // Show loading state
        button.classList.add('working');
        
        // Get product data
        const productHandle = button.getAttribute('data-product-handle');
        
        // Generate unique ID for modal
        const modalId = `modal-cart-${productHandle}`;
        
        // Clean up any existing cart quick view modals to prevent conflicts
        document.querySelectorAll('[id^="modal-cart-"]').forEach(existingModal => {
          existingModal.remove();
        });
        
        // Fetch product quick view template
        fetch(`/products/${productHandle}?view=quick-view`)
          .then(response => response.text())
          .then(text => {
            // Parse the HTML response
            const quickViewHTML = new DOMParser()
              .parseFromString(text, 'text/html')
              .querySelector('#product-quick-view');
            
            if (!quickViewHTML) {
              button.classList.remove('working');
              return;
            }
            
            // Create modal with content
            const quickViewContainer = document.createElement('div');
            quickViewContainer.innerHTML = `
              <modal-box 
                id="${modalId}"
                class="modal modal--product" 
                data-options='{
                  "enabled": false,
                  "showOnce": false,
                  "blockTabNavigation": true,
                  "closeByKey": true,
                  "openedModalBodyClass": "no-overflow"
                }'
                tabindex="-1" role="dialog" aria-modal="true" 
                aria-labelledby="${modalId}-title"
              >
                <div class="product-modal-content" style="z-index:9"></div>
                <span class="modal-background" data-js-close></span>
              </modal-box>
            `;
            
            quickViewModal = quickViewContainer.querySelector('modal-box');
            document.body.appendChild(quickViewModal);
            
            // Add content to the modal
            quickViewModal.querySelector('.product-modal-content').innerHTML = `
              ${quickViewHTML.innerHTML}
              <button class="product-quick-view__close" data-js-close aria-label="Close quick view">
                ${window.KROWN?.settings?.symbols?.close || '×'}
              </button>
            `;
            
            // Initialize quantity selector
            initializeQuantitySelectors(quickViewModal);
            
            // Initialize product functionality - do this before initializing switch type selectors
            if (typeof ProductHeaderHelper === 'function') {
              try {
                ProductHeaderHelper(`#${quickViewModal.querySelector('product-page').id}`);
              } catch (e) {
                // Could not initialize ProductHeaderHelper
              }
            }
            
            // Force reinitialization of product-variants component for new product
            const productVariantsElement = quickViewModal.querySelector('product-variants');
            if (productVariantsElement) {
              // Clear any existing state and reinitialize
              productVariantsElement.variantData = null;
              productVariantsElement.currentVariant = null;
              productVariantsElement.options = [];
              
              // Trigger reinitialization
              if (typeof productVariantsElement.init === 'function') {
                productVariantsElement.init();
              }
            }
            
            // Initialize scripts if needed
            if (!window.productPageScripts) {
              const scripts = quickViewModal.querySelectorAll('script');
              scripts.forEach(elm => {
                const script = document.createElement('script');
                script.src = elm.src;
                document.body.append(script);
              });
              window.productPageScripts = true;
            }
            
            // Always ensure TV selector script is loaded for modals
            const ensureTVSelectorScript = () => {
              return new Promise((resolve) => {
                if (document.querySelector('script[src*="component-tv-brand-selector.js"]')) {
                  // Script already exists, check if TVBrandSelector is available
                  if (typeof TVBrandSelector !== 'undefined' || customElements.get('tv-brand-selector')) {
                    resolve();
                  } else {
                    // Script exists but not loaded yet, wait for it
                    setTimeout(() => resolve(), 100);
                  }
                } else {
                  // Load the script
                  const tvSelectorScript = document.createElement('script');
                  tvSelectorScript.src = '/assets/component-tv-brand-selector.js';
                  tvSelectorScript.defer = true;
                  document.head.appendChild(tvSelectorScript);
                  
                  tvSelectorScript.onload = () => {
                    // Wait a bit more for the custom element to be defined
                    setTimeout(() => resolve(), 100);
                  };
                  
                  tvSelectorScript.onerror = () => {
                    resolve(); // Resolve anyway to prevent hanging
                  };
                }
              });
            };
            
            // Setup close button
            quickViewModal.querySelector('.product-quick-view__close').addEventListener('click', () => {
              quickViewModal.hide();
              // Return focus when modal closes
              button.focus();
            });
            
            // Handle add to cart in the modal
            if (quickViewModal.querySelector('[data-js-product-form]')) {
              const productForm = quickViewModal.querySelector('[data-js-product-form]');
              
              productForm.addEventListener('add-to-cart', () => {
                quickViewModal.hide();
                
                // Open cart sidebar if it exists
                if (!document.body.classList.contains('template-cart') && document.getElementById('site-cart-sidebar')) {
                  document.getElementById('site-cart-sidebar').show(null);
                }
                
                // Announce cart update for screen readers
                announceCartUpdate();
              });
              
              // Handle form submission validation
              const form = productForm.querySelector('form');
              if (form) {
                form.addEventListener('submit', (e) => {
                  const productVariants = quickViewModal.querySelector('product-variants');
                  if (productVariants && typeof productVariants.validateAllVariants === 'function') {
                    const isValid = productVariants.validateAllVariants();
                    if (!isValid) {
                      e.preventDefault();
                      e.stopPropagation();
                      return false;
                    }
                  }
                  // If validation passes, let the form submit naturally
                });
              }
            }
            
            // Show the modal after a short delay
            setTimeout(() => {
              quickViewModal.show();
              button.classList.remove('working');
              
              // Focus first focusable element in modal
              setTimeout(() => {
                const firstFocusable = quickViewModal.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
                if (firstFocusable) firstFocusable.focus();
              }, 100);
              
              // Dispatch a custom event for other components to know the quick view is loaded
              const quickViewLoadedEvent = new CustomEvent('quickViewLoaded', {
                bubbles: true,
                detail: { source: 'cart-footer-quick-view', modalId: modalId }
              });
              document.dispatchEvent(quickViewLoadedEvent);
              
              // Single initialization call after modal is fully rendered
              setTimeout(() => {
                // Force reinitialization of product-variants component for new product
                const productVariantsElement = quickViewModal.querySelector('product-variants');
                if (productVariantsElement) {
                  // Clear any existing state and reinitialize
                  productVariantsElement.variantData = null;
                  productVariantsElement.currentVariant = null;
                  productVariantsElement.options = [];
                  
                  // Trigger reinitialization
                  if (typeof productVariantsElement.init === 'function') {
                    productVariantsElement.init();
                  }
                }
                
                // Initialize switch type selectors after product variants are ready
                if (typeof window.initSwitchTypeSelectors === 'function') {
                  window.initSwitchTypeSelectors();
                  
                  // Ensure cart footer switch items are always shown as available
                  ensureCartFooterSwitchItemsAvailable(quickViewModal);
                }
                
                // Initialize TV brand selectors in the modal
                const tvBrandSelectors = quickViewModal.querySelectorAll('tv-brand-selector');
                if (tvBrandSelectors.length > 0) {
                  // Ensure script is loaded before initializing
                  ensureTVSelectorScript().then(() => {
                    const initializeTVSelectors = () => {
                      tvBrandSelectors.forEach((tvSelector) => {
                        // Force visibility first
                        tvSelector.style.display = 'block';
                        tvSelector.style.visibility = 'visible';
                        
                        // Check if already initialized
                        if (tvSelector.querySelector('.tv-dropdown__trigger')) {
                          return;
                        }
                        
                        // Try different initialization methods
                        if (typeof TVBrandSelector !== 'undefined') {
                          // Force re-initialization by creating a new instance
                          if (typeof tvSelector.init === 'function') {
                            tvSelector.init();
                          } else {
                            // Manually trigger the constructor logic
                            const instance = new TVBrandSelector();
                            instance.init.call(tvSelector);
                          }
                        } else if (customElements.get('tv-brand-selector')) {
                          customElements.upgrade(tvSelector);
                        }
                      });
                    };
                    
                    // Try immediate initialization
                    initializeTVSelectors();
                    
                    // Verify initialization worked and retry if needed
                    setTimeout(() => {
                      const uninitializedSelectors = Array.from(tvBrandSelectors).filter(
                        selector => !selector.querySelector('.tv-dropdown__trigger')
                      );
                      
                      if (uninitializedSelectors.length > 0) {
                        initializeTVSelectors();
                      }
                    }, 300);
                  });
                }
                
                // Also re-initialize quantity selectors
                initializeQuantitySelectors(quickViewModal);
              }, 500);
            }, 250);
          })
          .catch(error => {
            button.classList.remove('working');
          });
      });
    });
  }
  
  // Function to initialize quantity selectors within the modal context
  function initializeQuantitySelectors(container) {
    if (!container) return;
    
    const quantitySelector = container.querySelector('.quantity-selector');
    if (!quantitySelector) return;
    
    const quantityInput = quantitySelector.querySelector('input[type="number"]');
    const decreaseButton = quantitySelector.querySelector('.quantity-decrease');
    const increaseButton = quantitySelector.querySelector('.quantity-increase');
    
    if (!quantityInput || !decreaseButton || !increaseButton) return;
    
    function updateQuantity(delta) {
      let value = parseInt(quantityInput.value) || 0;
      value = Math.max(1, Math.min(99, value + delta));
      quantityInput.value = value;
      quantityInput.setAttribute('aria-valuenow', value);
      quantitySelector.setAttribute('aria-valuenow', value);
      updateButtonStates();
    }
    
    function updateButtonStates() {
      const value = parseInt(quantityInput.value);
      decreaseButton.disabled = value <= 1;
      increaseButton.disabled = value >= 99;
    }
    
    // Clone the buttons to remove existing event listeners
    const newDecreaseButton = decreaseButton.cloneNode(true);
    const newIncreaseButton = increaseButton.cloneNode(true);
    
    decreaseButton.parentNode.replaceChild(newDecreaseButton, decreaseButton);
    increaseButton.parentNode.replaceChild(newIncreaseButton, increaseButton);
    
    // Add event listeners
    newDecreaseButton.addEventListener('click', () => updateQuantity(-1));
    newIncreaseButton.addEventListener('click', () => updateQuantity(1));
    
    quantityInput.addEventListener('input', function() {
      let value = parseInt(this.value) || 1;
      value = Math.max(1, Math.min(99, value));
      this.value = value;
      updateButtonStates();
    });
    
    quantityInput.addEventListener('keydown', function(event) {
      if (event.key === 'ArrowUp') {
        event.preventDefault();
        updateQuantity(1);
      } else if (event.key === 'ArrowDown') {
        event.preventDefault();
        updateQuantity(-1);
      }
    });
    
    // Initialize state
    updateButtonStates();
  }
  
  // Helper function to announce cart updates for screen readers
  function announceCartUpdate() {
    const announcer = document.querySelector('.cart-update-announcement');
    if (announcer) {
      announcer.textContent = 'Product added to cart';
      setTimeout(() => {
        announcer.textContent = '';
      }, 2000);
    }
  }
  
  // Helper function to ensure cart footer switch items are always shown as available
  function ensureCartFooterSwitchItemsAvailable(container) {
    if (!container) return;
    
    // Find all switch type items
    const switchItems = container.querySelectorAll('.switch-type-item');
    
    switchItems.forEach(item => {
      // Remove disabled class
      item.classList.remove('disabled');
      item.setAttribute('data-available', 'true');
      
      // Clear any availability messages
      const switchType = item.getAttribute('data-switch-type');
      if (switchType) {
        const messageEl = container.querySelector(`.availability-message[data-for="${switchType}"]`);
        if (messageEl) {
          messageEl.textContent = '';
        }
      }
    });
  }

  // Global event listener for quick view loaded events
  document.addEventListener('quickViewLoaded', function(event) {
    // Find the modal that was just loaded
    const modalId = event.detail?.modalId;
    let targetModal = document;
    
    if (modalId) {
      targetModal = document.getElementById(modalId) || document;
    }
    
    // Initialize TV selectors in the modal
    const tvBrandSelectors = targetModal.querySelectorAll('tv-brand-selector');
    if (tvBrandSelectors.length > 0) {
      // Use the same promise-based approach
      const ensureTVSelectorScriptGlobal = () => {
        return new Promise((resolve) => {
          if (typeof TVBrandSelector !== 'undefined' || customElements.get('tv-brand-selector')) {
            resolve();
          } else if (document.querySelector('script[src*="component-tv-brand-selector.js"]')) {
            // Script exists but not ready, wait for it
            setTimeout(() => resolve(), 200);
          } else {
            // Load the script
            const tvSelectorScript = document.createElement('script');
            tvSelectorScript.src = '/assets/component-tv-brand-selector.js';
            tvSelectorScript.defer = true;
            document.head.appendChild(tvSelectorScript);
            
            tvSelectorScript.onload = () => setTimeout(() => resolve(), 100);
            tvSelectorScript.onerror = () => resolve();
          }
        });
      };
      
      ensureTVSelectorScriptGlobal().then(() => {
        tvBrandSelectors.forEach((tvSelector) => {
          tvSelector.style.display = 'block';
          tvSelector.style.visibility = 'visible';
          
          if (!tvSelector.querySelector('.tv-dropdown__trigger')) {
            if (typeof TVBrandSelector !== 'undefined') {
              if (typeof tvSelector.init === 'function') {
                tvSelector.init();
              } else {
                const instance = new TVBrandSelector();
                instance.init.call(tvSelector);
              }
            } else if (customElements.get('tv-brand-selector')) {
              customElements.upgrade(tvSelector);
            }
          }
        });
      });
    }
  });